/* eslint-disable react-hooks/exhaustive-deps */
import {
  ActionButton,
  Select
} from "components"
import { Fragment, useEffect, useMemo } from "react"
import {
  Controller,
  FormProvider,
  useForm,
  useFormContext,
} from "react-hook-form"
import moment from "moment"
import { FormStateProjectProfile } from "../types/ProfileTypes"
import { convertNumber, useToggle } from "utils"
import { BillType } from "../types/BillTypes"


type Action = "add" | "edit"

type ItemProps = {
    index?: number
    action: Action
    defaultValues?: BillType
    isHideForm?: boolean
    onCancelEditing?: () => void
    onDeleteData?: () => void
    onSubmitData: (value: BillType) => void
    dataProject: FormStateProjectProfile
    dropdownBoq: {
      value:string,
      label:string
    }[]
}

export function TableBillItem(props: ItemProps) {
    const isHideForm = useToggle(props.isHideForm ?? true)
    const defaultValues: BillType = useMemo(
        () => ({
            project_transaction_id:props.defaultValues?.project_transaction_id ?? null,
            bill_detail_id: props.defaultValues?.bill_detail_id ?? 0,
            quantity_bill: props.defaultValues?.quantity_bill ?? 0,
            quantity_unit: props.defaultValues?.quantity_unit ?? 0,
            product_id: props.defaultValues?.product_id ?? 0,
            project_id: props.defaultValues?.project_id ?? 0,
            price_bill: props.defaultValues?.price_bill ?? 0,
            discount: props.defaultValues?.discount ?? 0,
            total: props.defaultValues?.total ?? 0,
            tax_id: props.defaultValues?.tax_id ?? 0,
            transaction_date:props.defaultValues?.transaction_date ?? '',
            company_code: props.defaultValues?.company_code ?? "",
            tax_rate: props.defaultValues?.tax_rate ?? 0,
            total_tax_paid: props.defaultValues?.total_tax_paid ?? 0,
            product_name: props.defaultValues?.product_name ?? "",
            vendor_description: props.defaultValues?.vendor_description ?? "",
            tax_name: props.defaultValues?.tax_name ?? "",
            unit_convention_id: props.defaultValues?.unit_convention_id ?? 0,
            unit_convention: props.defaultValues?.unit_convention ?? "",
            unit_measure_id: props.defaultValues?.unit_measure_id ?? 0,
            unit_measure: props.defaultValues?.unit_measure ?? "",
            total_qty_reject: props.defaultValues?.total_qty_reject ?? 0,
            total_nilai_reject: props.defaultValues?.total_nilai_reject ?? 0,
            total_tax_reject: props.defaultValues?.total_tax_reject ?? 0,
            vendor_id: props.defaultValues?.vendor_id ?? 0,
            vendor_name: props.defaultValues?.vendor_name ?? "",
            trx_code: props.defaultValues?.trx_code ?? "",
            project_boq_id: props.defaultValues?.project_boq_id ?? 0,
            boq_name: props.defaultValues?.boq_name ?? "",
        }),
        [props.defaultValues]
    )

    const methods = useForm<BillType>({
        defaultValues,
        // resolver: yupResolver(validationBoqSchema)
    })

    useEffect(() => methods.reset(defaultValues), [defaultValues])

    const { watch } = methods;
    const total = Number(watch('total')) + Number(watch('total_tax_paid'))

    console.log(props.index);
    
  return (
    <FormProvider {...methods}>
      <tr className="">
        {isHideForm.isActive ? (
          <td colSpan={9} />
        ) : (
          <Fragment>
            <td className="text-center">{Number(props.index)+1}</td>
            <td >
              <Controller
                control={methods.control}
                name="trx_code"
                render={({ field }) => (
                  <div>{field.value}</div>
                )}
              />
            </td>

            <td>
              <Controller
                control={methods.control}
                name="transaction_date"
                render={({ field }) => (
                  <div>{moment(field.value).format('DD/MM/YYYY')}</div>
                )}
              />
            </td>

            <td>
              <Controller
                control={methods.control}
                name="vendor_name"
                render={({ field }) => (
                  <div>{field.value}</div>
                )}
              />
            </td>

            <td>
              <Controller
                control={methods.control}
                name="vendor_description"
                render={({ field }) => (
                  <div>{field.value}</div>
                )}
              />
            </td>

            <td>
              <Controller
                control={methods.control}
                name="quantity_bill"
                render={({ field }) => (
                  <div>{field.value}</div>
                )}
              />
            </td>

            <td>
              <Controller
                control={methods.control}
                name="unit_measure"
                render={({ field }) => (
                  <>{field.value}</>
                )}
              />
            </td>

            <td>
              <Controller
                control={methods.control}
                name="price_bill"
                render={({ field }) => (
                  <>{convertNumber(Number(field.value)).intoCurrency}</>
                )}
              />
            </td>

            <td>
              <Controller
                control={methods.control}
                name="discount"
                render={({ field, fieldState }) => (
                  <>{convertNumber(Number(field.value)).intoCurrency}</>
                )}
              />
            </td>

            <td>
              <Controller
                control={methods.control}
                name="total"
                render={({ field }) => (
                  <>{convertNumber(Number(field.value)).intoCurrency}</>
                )}
              />
            </td>

            <td>
              <Controller
                control={methods.control}
                name="total_tax_paid"
                render={({ field, fieldState }) => (
                  <>{convertNumber(Number(field.value)).intoCurrency}</>
                )}
              />
            </td>

            <td>
              {convertNumber(Number(total)).intoCurrency}
            </td>

            <td className="min-w-[100px]">
             <BOQ dropdown={props.dropdownBoq}/>
            </td>

        
            <td className="text-center">
              <section className="flex justify-center items-center">
                {props.action === "edit" && (
                  <ActionButton.Close
                    permission="AT021"
                    onClick={props?.onCancelEditing}
                  />
                )}

                <ActionButton.Add
                  permission="AT021"
                  onClick={() => {
                    methods.handleSubmit((data) =>
                      props.onSubmitData(data)
                    )()
                  }}
                />

                {props.action === "add" && (
                  <ActionButton.Close
                    permission="AT021"
                    onClick={isHideForm.toggle}
                  />
                )}
              </section>
            </td>
          </Fragment>
        )}
      </tr>
    </FormProvider>
  )
}


type BoqDropdownType={
  dropdown:{
    value:string,
    label:string
  }[]
}
function BOQ (props:BoqDropdownType) {
    
    const { control, setValue } = useFormContext<BillType>()
   console.log(props.dropdown);
   
    return (
      <Fragment>
        <Controller
          control={control}
          name="project_boq_id"
          render={({ field, fieldState }) => {
            return (
              <section>
                <Select
                  className="w-full"
                  placeholder="Select BOQ"
                  error={fieldState.error?.message}
                  options={props.dropdown}
                  value={
                    field.value
                      ? props.dropdown.find((item) => Number(item.value) === field.value)
                      : null
                  }
                  onChange={(e) => {
                      field.onChange(e?.value)
                      setValue("boq_name", e?.label ?? "")
                  }}
                />
              </section>
            )
          }}
        />
      </Fragment>
    )
  }